<template>
    <Bulletins :Mode="false" Type="4"></Bulletins>
</template>

<script>
import Vue from 'vue';
import Bulletins from '@/components/DPEBB/Administrator/Bulletins.vue'
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID :4,
        }
    },
    components: {

        Bulletins,

    },
created: function() {

    this.$emit('update:layout', LayoutDefault);
},    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetHearingID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetHearingID);
    },
}
</script>

<style>

</style>
